import { ClosingMethod } from 'services/campaign/types';
import { FormValues } from '../types';
import { progressScreeningStatusMapper } from 'modules/conversations/utils';
import { ConversationStatus } from 'generated-graphql/types';

export const useRequirementConditionsOptionsAvailable = (
  value: FormValues,
  closingMethod: ClosingMethod | undefined | null
) => {
  if (!closingMethod) return { conversationStatusAvailableOptions: [] };

  const requirementConditions = value
    .map((item) => item.requirementConditions)
    .flat();

  const conversationStatusesUsed = requirementConditions
    .map((condition) => condition.conversationStatus)
    .filter(Boolean);

  const progressedScreeningStatus =
    progressScreeningStatusMapper(closingMethod);

  const conversationStatuses = [
    progressedScreeningStatus,
    ConversationStatus.CompletedRejected,
    ConversationStatus.CompletedNotInterested,
    ConversationStatus.Completed,
    ConversationStatus.OptedOut
  ].filter(
    (status) => !conversationStatusesUsed.includes(status as ConversationStatus)
  );

  return {
    conversationStatusAvailableOptions: conversationStatuses
  };
};
